<p-steps
  [model]="steps"
  [activeIndex]="currentStep"
  [readonly]="true"
  class="mb-4"></p-steps>

<p class="text-color-secondary mt-0 mb-4">
  Configurazione per <strong>{{ data.label ? data.label + ' - ' : '' }}{{ data.email }}</strong>
</p>

<!-- Step 0: Commessa -->
<div *ngIf="currentStep === 0">
  <div class="field flex flex-column">
    <label for="agreement">Commessa<sup>*</sup></label>
    <p-autoComplete
      inputId="agreement"
      [(ngModel)]="selectedAgreement"
      [suggestions]="suggestedAgreements"
      (completeMethod)="filterAgreements($event)"
      field="name"
      dataKey="id"
      [forceSelection]="true"
      [dropdown]="true"
      appendTo="body"
      dropdownIcon="pi pi-search"
      emptyMessage="Nessuna commessa trovata"
      placeholder="Cerca commessa...">
      <ng-template
        let-agreement
        pTemplate="item">
        {{ agreement.name }} ({{ agreement.identifier }})
      </ng-template>
      <ng-template
        let-agreement
        pTemplate="selectedItem">
        {{ agreement.name }} ({{ agreement.identifier }})
      </ng-template>
    </p-autoComplete>
  </div>
</div>

<!-- Step 1: Macroarea -->
<div *ngIf="currentStep === 1">
  <label class="block mb-3">Macroarea<sup>*</sup></label>
  <div class="grid">
    <div
      class="col-6 md:col-3"
      *ngFor="let area of macroAreas">
      <div
        class="macro-area-card"
        [class.selected]="selectedMacroArea === area.value"
        (click)="selectMacroArea(area.value)">
        <i [class]="area.icon"></i>
        <span>{{ area.label }}</span>
      </div>
    </div>
  </div>
</div>

<!-- Step 2: Stati (non per DDT) -->
<div *ngIf="currentStep === 2">
  <div class="field flex flex-column">
    <label for="statuses">Stati {{ macroAreaLabel(selectedMacroArea!) }}<sup>*</sup></label>
    <p-multiSelect
      inputId="statuses"
      placeholder="Seleziona gli stati per cui inviare la notifica"
      [filter]="true"
      [showClear]="true"
      optionLabel="label"
      optionValue="id"
      styleClass="w-full"
      appendTo="body"
      [displaySelectedLabel]="true"
      [emptyMessage]="'Nessuno stato trovato'"
      [options]="availableStatuses"
      [(ngModel)]="selectedStatusIds">
    </p-multiSelect>
    <small
      *ngIf="isLoadingStatuses"
      class="text-color-secondary">Caricamento stati...</small>
  </div>
</div>

<!-- Step 3: Allegati -->
<div *ngIf="currentStep === 3">
  <div class="field flex flex-column">
    <label for="attachments">Allegati</label>
    <p-multiSelect
      inputId="attachments"
      placeholder="Seleziona gli allegati da inviare con la mail"
      [filter]="false"
      [showClear]="true"
      optionLabel="name"
      optionValue="id"
      styleClass="w-full"
      appendTo="body"
      [displaySelectedLabel]="true"
      [emptyMessage]="'Nessun allegato disponibile per questa macroarea'"
      [options]="availableAttachments"
      [(ngModel)]="selectedAttachmentIds">
    </p-multiSelect>
    <small
      *ngIf="isLoadingAttachments"
      class="text-color-secondary">Caricamento allegati...</small>
  </div>
</div>

<div class="flex flex-row justify-content-between align-items-center mt-4">
  <p-button
    label="Annulla"
    styleClass="p-button-text"
    (click)="cancel()"></p-button>
  <div class="flex gap-2">
    <p-button
      *ngIf="currentStep > 0"
      label="Indietro"
      styleClass="p-button-outlined"
      (click)="back()"></p-button>
    <p-button
      *ngIf="currentStep < 3"
      label="Avanti"
      [disabled]="!canGoNext"
      (click)="next()"></p-button>
    <p-button
      *ngIf="currentStep === 3"
      label="Salva"
      [loading]="isSaving"
      (click)="save()"></p-button>
  </div>
</div>
